import { render, staticRenderFns } from "./pdf-view-modal.vue?vue&type=template&id=4a1c65bf&scoped=true"
import script from "./pdf-view-modal.vue?vue&type=script&lang=js"
export * from "./pdf-view-modal.vue?vue&type=script&lang=js"
import style0 from "./pdf-view-modal.vue?vue&type=style&index=0&id=4a1c65bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c65bf",
  null
  
)

export default component.exports